// src/data/controllers/subscriptionPlansController.js

import api from "utils/axios";

// Get all subscription plans
export async function getSubscriptionPlans(targetUserType = null) {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/users/get-subscription-plans`);

    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get plans");
    }

    const plans = data.data || [];
    let filteredPlans = plans;

    if (targetUserType) {
      filteredPlans = plans.filter((plan) => plan.targetUserType === targetUserType);
    }

    return {
      success: true,
      data: filteredPlans,
      message: "Plans fetched successfully",
    };
  } catch (error) {
    console.error("getSubscriptionPlans error:", error);
    throw new Error("Failed to fetch subscription plans");
  }
}

export async function updateSubscriptionPlan(planId, planData) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/users/update-subscription-plan`, {
      planId,
      planData,
    });

    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get plans");
    }

    return data.data;
  } catch (error) {
    console.error("updateSubscriptionPlan error:", error);
    throw error;
  }
}
